export default {
      id: "eye-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.svg#eye",
      toString: function () {
        return this.url;
      }
    }